import { render, staticRenderFns } from "./zoomBtns.vue?vue&type=template&id=01fed87e&scoped=true&"
import script from "./zoomBtns.vue?vue&type=script&lang=js&"
export * from "./zoomBtns.vue?vue&type=script&lang=js&"
import style0 from "./zoomBtns.vue?vue&type=style&index=0&id=01fed87e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fed87e",
  null
  
)

/* custom blocks */
import block0 from "./zoomBtns.vue?vue&type=custom&index=0&blockType=comment"
if (typeof block0 === 'function') block0(component)

export default component.exports